// ============================================================================
// Woodcutting System Types - Axe tiers and tree identification
// ============================================================================
import { ItemType } from '../items/types.js';
import { ObjectType } from '../objects/types.js';
// All axe types with their capabilities
export const AXE_TIERS = {
    [ItemType.WOODEN_AXE]: {
        itemType: ItemType.WOODEN_AXE,
        choppingSpeedMultiplier: 1.0,
        woodcuttingLevelRequired: 1,
    },
    [ItemType.STONE_AXE]: {
        itemType: ItemType.STONE_AXE,
        choppingSpeedMultiplier: 1.3,
        woodcuttingLevelRequired: 1,
    },
    [ItemType.BRONZE_AXE]: {
        itemType: ItemType.BRONZE_AXE,
        choppingSpeedMultiplier: 1.6,
        woodcuttingLevelRequired: 10,
    },
    [ItemType.IRON_AXE]: {
        itemType: ItemType.IRON_AXE,
        choppingSpeedMultiplier: 2.0,
        woodcuttingLevelRequired: 15,
    },
    [ItemType.STEEL_AXE]: {
        itemType: ItemType.STEEL_AXE,
        choppingSpeedMultiplier: 2.5,
        woodcuttingLevelRequired: 25,
    },
    [ItemType.MITHRIL_AXE]: {
        itemType: ItemType.MITHRIL_AXE,
        choppingSpeedMultiplier: 3.5,
        woodcuttingLevelRequired: 45,
    },
    [ItemType.STARMETAL_AXE]: {
        itemType: ItemType.STARMETAL_AXE,
        choppingSpeedMultiplier: 5.0,
        woodcuttingLevelRequired: 65,
    },
};
// ============================================================================
// Tree Identification
// ============================================================================
/** Object types that are trees and require an axe to chop */
const TREE_OBJECTS = new Set([
    ObjectType.TREE_OAK,
    ObjectType.TREE_PINE,
    ObjectType.TREE_BIRCH,
]);
// ============================================================================
// Helper Functions
// ============================================================================
/** Check if an object type is a tree */
export const isTree = ({ objectType }) => {
    return TREE_OBJECTS.has(objectType);
};
/** Check if an object type requires an axe to harvest */
export const requiresAxe = ({ objectType }) => {
    return TREE_OBJECTS.has(objectType);
};
/** Get axe tier configuration for an item type */
export const getAxeTier = ({ itemType }) => {
    return AXE_TIERS[itemType] ?? null;
};
/** Check if an item is an axe */
export const isAxeItem = ({ itemType }) => {
    return AXE_TIERS[itemType] !== undefined;
};
// Sorted axe tiers by speed (descending) for best-axe lookup
const SORTED_AXE_TIERS = Object.values(AXE_TIERS).sort((a, b) => b.choppingSpeedMultiplier - a.choppingSpeedMultiplier);
/** Get the best axe from a list of item types (highest speed multiplier) */
export const getBestAxeFromInventory = ({ inventoryItemTypes, }) => {
    const inventorySet = new Set(inventoryItemTypes);
    for (const tier of SORTED_AXE_TIERS) {
        if (inventorySet.has(tier.itemType)) {
            return tier;
        }
    }
    return null;
};
//# sourceMappingURL=types.js.map